import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

export const StyledDownloadExtensionContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledDEHeaderContainerWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 429px;
    background: linear-gradient(308deg, #a2cff6 2.35%, #c2e0e9 35.84%, #f5f7fc 65.94%);
`;

export const StyledDEHeaderContainer = styled.div`
    display: flex;
    width: 883px;
    flex-direction: column;
    row-gap: 24px;
`;

export const StyledDEHeaderProductContainer = styled.div`
    display: flex;
    align-items: center;
    margin-top: 56px;
`;

export const StyledDEHeaderTitle = styled.div`
    display: flex;
    ${mixins.setFontVariant("h2", colorsPalettes.carbon[500])};
`;

export const StyledDEDescription = styled(FlexColumn)`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon[400])};
`;

export const StyledDEButtonWrapper = styled.div`
    display: flex;
    width: fit-content;
`;

export const StyledDEFooterButtonWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 90px;
`;

export const StyledDEContentWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 54px;
`;

export const StyledDEContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 883px;
`;

export const StyledItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 87px;
`;

export const StyledTextBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 302px;
`;

export const StyledTextTitleBlock = styled.div`
    display: flex;
    ${mixins.setFontVariant("h4", colorsPalettes.carbon[500])};
`;

export const StyledTextDescriptionBlock = styled(FlexColumn)`
    margin-top: 8px;
    ${mixins.setFontVariant("subTitle3Alt", colorsPalettes.carbon[400])};
`;

export const StyledImageContainer = styled.div`
    display: flex;
    max-width: 419px;
    img {
        border-radius: 16px;
        box-shadow: 0px 18px 34px 0px rgba(14, 30, 62, 0.12);
    }
`;

export const StyledCompanyDataBlock = styled(StyledTextBlock)`
    width: 357px;
`;

export const StyledSalesIntelligenceBlock = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 9px;
    height: 18px;
    border-left: 1px solid #a9b6d7;

    img {
        margin-right: 5px;
    }
`;

export const StyledSwLogoItemWrapper = styled.div`
    display: flex;
    width: 131px;

    & > div {
        padding-left: 0;
        &:hover {
            background: none;
        }
    }
`;

export const StyledSITitleText = styled.span`
    ${mixins.setFontVariant("h5", colorsPalettes.carbon[500])};
    font-size: 19.264px;
    line-height: 20px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: -0.385px;
`;
